import React, { useRef, useEffect } from 'react';
import { Sparkles } from 'lucide-react';

const AiEditPopup = ({
  isVisible,
  inputValue,
  onInputChange,
  onSubmit,
  onCancel,
  isProcessing
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (isVisible && inputRef.current) {
      setTimeout(() => {
        inputRef.current.focus();
      }, 100);
    }
  }, [isVisible]);

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className="ai-edit-popup-overlay"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000
      }}
      onClick={e => {
        if (e.target === e.currentTarget && !isProcessing) {
          onCancel();
        }
      }}
    >
      <div
        className="ai-edit-popup"
        style={{
          backgroundColor: '#fff',
          borderRadius: '8px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          width: '400px',
          maxWidth: '90vw',
          display: 'flex',
          flexDirection: 'column',
          gap: '15px'
        }}
      >
        <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Sparkles size={20} style={{ color: '#e4b17a' }} />
          Edit Grading Criteria with AI
        </h3>
        <textarea
          ref={inputRef}
          value={inputValue}
          placeholder="Type your request here, e.g. 'Make the grading criteria more detailed' or 'Add a criteria for partial credit'"
          style={{
            padding: '10px 12px',
            borderRadius: '4px',
            border: '1px solid #d1d5db',
            resize: 'vertical',
            minHeight: '100px',
            fontSize: '14px',
            fontFamily: 'inherit'
          }}
          disabled={isProcessing}
          onChange={onInputChange}
          onKeyDown={e => {
            if (e.key === 'Enter' && e.ctrlKey && !isProcessing) {
              onSubmit();
            } else if (e.key === 'Escape' && !isProcessing) {
              onCancel();
            }
          }}
        />

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <button
            style={{
              padding: '8px 12px',
              borderRadius: '4px',
              border: '1px solid #d1d5db',
              backgroundColor: '#f3f4f6',
              cursor: isProcessing ? 'not-allowed' : 'pointer',
              fontSize: '14px',
              opacity: isProcessing ? 0.6 : 1
            }}
            disabled={isProcessing}
            onClick={() => !isProcessing && onCancel()}
          >
            Cancel
          </button>
          <button
            style={{
              padding: '8px 16px',
              borderRadius: '4px',
              border: 'none',
              background: 'linear-gradient(to right, #e4b17a, #c99b69)',
              color: '#fff',
              cursor: isProcessing ? 'not-allowed' : 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              opacity: isProcessing ? 0.6 : 1,
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}
            disabled={isProcessing}
            onClick={onSubmit}
          >
            {isProcessing ? (
              <>
                <span
                  className="spinner"
                  style={{
                    width: '16px',
                    height: '16px',
                    border: '2px solid rgba(255, 255, 255, 0.3)',
                    borderRadius: '50%',
                    borderTopColor: '#fff'
                  }}
                ></span>
                Processing...
              </>
            ) : (
              'Confirm'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AiEditPopup;